<template>
  <div class="i-date-picker">
    <el-date-picker
      :key="key"
      ref="datePickerRef"
      v-model="inputVal"
      :type="type"
      :format="format"
      :value-format="valueFormat"
      placeholder="DD-MM-YYYY"
      :range-separator="rangeSeparator"
      unlink-panels
      :clearable="clearable"
      :disabled="disabled"
      size="small"
      :defaultTime="defaultTime"
      :picker-options="allPickerOptions"
      @input.native="inputValue"
      @change="handleSelect"
      @focus="focus"
    />
  </div>
</template>
<script>
export default {
  name: 'DatePicker',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    type: {
      type: String,
      default: 'date'
    },
    defaultTime:{
      type: [String, Number, Array],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    pickerOptions: {
      type: Object,
      default: () => ({})
    },
    format:{
      type: String,
      default: 'dd-MM-yyyy'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    rangeSeparator: {
      type: String,
      default: 'to'
    },
    index: {
      type: Number,
      default: 0
    },
    _45daysComfirm:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVal: this.type === 'date'? '': [],
      isDefault:false,
      allPickerOptions: {
        ...this.pickerOptions
      },
      key: 1
    }
  },
  watch: {
    // inputVal: function(val) {
    //   this.$emit('input', val)
    // },
    value: {
      immediate: true,
      handler(val) {
        if(val === null && this.type === 'daterange') {
          this.inputVal = []
        } else {
          // 後端接口可能會傳 null
          if(this.checkValue(val) || this.checkValue(this.inputVal)) {
            this.inputVal = val
          }
        }
      }
    },
    inputVal: {
      // immediate: true,
      deep: true,
      handler(val, old) {
        if(val === null && this.type === 'daterange') {
          this.inputVal = []
        } else {
          this.$emit('input', val)
          this.$emit('change', val,this.index)
        }
      }
    },
    pickerOptions:{
      immediate: true,
      deep: true,
      handler(val){
        this.allPickerOptions = null
        this.allPickerOptions = val
        this.key = this.key + 1
      }
    }
  },
  methods: {
    inputValue(dom) {
      console.log('dom====')
      if(this.type === 'date') {
        let value = dom.target.value
        let str = value.replace(/[^\d]/g, '')
        let len = str.length
        let result = ''
        if (len >= 8) {
          console.log(dom)
          result = `${str.slice(4, len)}-${str.slice(2, 4)}-${str.slice(0, 2)}`
          this.inputVal = result
          result = `${str.slice(0, 2)}-${str.slice(2, 4)}-${str.slice(4, len)}`
          this.$refs['datePickerRef'].userInput = result
        }
      }
    },
    checkValue(value) {
      if(value === '' || value === null) {
        return false
      }
      return true
    },

    handleSelect(val){
      if(this._45daysComfirm){
        let selectTime = new Date(val).getTime()
        let now = new Date().getTime()
        let diff = (selectTime - now) / (3600 * 1000 * 24)
        if(diff > 45){
          this.$ConfirmBox({
            confirmBtn: 'Comfirm',
            message: 'EFFECTIVE DATE OVER 45 DAYS'
          }).catch(() => {
            this.inputVal = ''
          })
        }
      }
    },

    focus(val){
      this.$emit('focus',val)
    }
  }
}
</script>
<style lang="scss" scoped>
.i-date-picker {
  width: 100%;
  .el-date-editor.el-input, .el-date-editor {
    width: 100%;
  }
}
/deep/.el-input__icon{
  line-height: 24px !important;
}
</style>

